import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteEvent($companyId: ID!, $id: ID!) {
    deleteEvent(companyId: $companyId, id: $id) {
      event {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
